export default [
  {
    path: '/card/create',
    name: 'card-create',
    component: () => import('@/v3/modules/card/views/oldcard/create/index')
  },
  {
    path: '/card/stand',
    name: 'card-stand',
    component: r => require(['@/v3/modules/card/views/oldcard/stand'], r)
  },
  {
    path: '/card/zujuan',
    name: 'card-zujuan',
    meta: {
      title: '组卷制卡'
    },
    component: r => require(['@/v3/modules/card/views/zujuan/SheetCreate'], r)
  }
]
